import {  BasePortalOutlet,  CdkPortalOutlet,  ComponentPortal,  TemplatePortal} from '@angular/cdk/portal';
import {  Component,  ComponentRef,  EmbeddedViewRef,  ViewChild,  ChangeDetectorRef} from '@angular/core';

import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { PopoverArrowDirective } from './../popover-arrow.directive';
import { PopoverCloseDirective } from './../popover-close.directive';
import { PopoverRef } from '../popover-ref';

/**
 * Internal component that wraps user-provided popover content.
 */
@Component({
    selector: 'p1-popover',
    imports: [
    OverlayModule,
    PortalModule,
    PopoverArrowDirective
],
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss']
})
export class PopoverComponent extends BasePortalOutlet {
  @ViewChild(CdkPortalOutlet, { static: true })
  portalOutlet!: CdkPortalOutlet;

  attachComponentPortal<T>(componentPortal: ComponentPortal<any> ): ComponentRef<T> {
    return this.portalOutlet.attachComponentPortal(componentPortal);
  }

  attachTemplatePortal<C>(portal: TemplatePortal<C>): EmbeddedViewRef<C> {
    return this.portalOutlet.attachTemplatePortal(portal);
  }
}